module.exports = __webpack_public_path__ + "static/img/w-3.e25c7f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/worldView/w-3.jpg
// module id = MbP0
// module chunks = 1